import POI from '../classes/POI';

/**
 * An IIFE service which provides a method of loading, storing, filtering, and referencing all
 *  available Points of Interest (POI)
 *
 * @function POIService
 * @returns {object} Various public interface methods
 */
const POIService = (function() {
    let POIsByMap = {}, POIsByCategory = {};

    // *** Public interface ***//

    return {
        InitializePOIs: function (name, mapPOIs) {
            parsePOIs(name, mapPOIs);
        },
        GetPOIsForMap: function (name) {
            return POIsByMap[name];
        },
    }

    // *** Private methods ***//
    /**
     * Parses SVG POI elements into POI objects
     *
     * @param {object} mapName The object of the map
     * @param {array{DOMElement}} mapPOIs An array of DOM elements to parse for POI details
     */
    function parsePOIs (mapName, mapPOIs) {
        // Initialize map groups

        if (!POIsByMap[mapName.id]) {
            POIsByMap[mapName.id] = [];
        }

        // Sort POIs by category
        for (var i = 0; i < mapPOIs.length; i++) {
            const mapPOI = mapPOIs[i];

            let newPOI = new POI(
                mapPOI.id,
                mapPOI.dataset.title,
                mapPOI.dataset.category,
                mapPOI.dataset.description,
                mapName,
            );

            // Initialize category groups
            if (!POIsByCategory[POI.category]) {
                POIsByCategory[POI.category] = [];
            }

            // Store POI by category
            POIsByCategory[POI.category].push(newPOI);

            // Store POI by map
            POIsByMap[mapName.id].push(newPOI);

            // TODO: THese are great, but where can they be accessed after this????
        }
    }

})();

export default POIService;



// WEBPACK FOOTER //
// ./src/services/POI.js